import React from 'react'
import { Input } from "baseui/input";
import { FormControl } from "baseui/form-control";

const InputBox = ({ value, onChange, placeholder, label, readOnly }) => {
    return (
        <FormControl
            label={() => label}
        >
            <Input
                value={value}
                onChange={readOnly ? () => { } : e => onChange(e.target.value)}
                placeholder={placeholder}
            />
        </FormControl>
    )
}

export default InputBox